import { render, staticRenderFns } from "./OutletDetailsNew.vue?vue&type=template&id=2d025321&scoped=true&"
import script from "./OutletDetailsNew.vue?vue&type=script&lang=js&"
export * from "./OutletDetailsNew.vue?vue&type=script&lang=js&"
import style0 from "./OutletDetailsNew.vue?vue&type=style&index=0&id=2d025321&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d025321",
  null
  
)

export default component.exports